import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { WebServiceService } from '../../shared/services/web-service.service';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';

@Component({
  selector: 'app-additional-attachment',
  templateUrl: './additional-attachment.component.html',
  styleUrls: ['./additional-attachment.component.scss']
})
export class AdditionalAttachmentComponent implements OnInit {

  @Input() attachment: any;
  @Input() attachment_title: any;
  @Input() is_additional: boolean;

  @Output()
  sendAction = new EventEmitter()
  companyThemeBlockColor: any = "";
  CompanyThemetextColor: any = "";
  constructor(private webService: WebServiceService,public _localStorageService: LocalStorageService) {
  }
  ngOnInit() {
    this.is_additional=this.is_additional?this.is_additional:false;
    console.log(this.attachment);
    if(this.is_additional)
    {
      if(Array.isArray(this.attachment))
      {
for(let i of this.attachment)
{
  i.additional_savedFiles=i.additional_savedFiles?i.additional_savedFiles:[]
  //console.log(i.additional_savedFiles);
  if(i.additional_savedFiles)
  {
    for(let j of i.additional_savedFiles)
    {
      j.filetype=this.getFileExtension(j.attachment);
      j.iconclass=this.getFileIcon(this.getFileExtension(j.attachment));
      j.display=j.display_name;

  }


}
  }
}

if(this.attachment)
{
  for(let i of this.attachment)
  {
    i.attachment_type=i.attachment_type?i.attachment_type:i.display;
  }
}
 this.attachment=this.attachment.filter((v)=>{return v.additional_savedFiles.length>0});


    }
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : "#035168";
   this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : "#FFFFFF";
  }
  getFilename(name) {
    return name.substring(0, name.lastIndexOf('.'));


  }
  getFileExtension(filename) {
    return (filename!=''&&filename!=undefined&&filename!=null)?filename.split('.').pop():'';
  }
  getFileIcon(type) {
    let class_name: any = "file-text-o";

    switch (type.toLowerCase()) {
      case 'pdf':
        class_name = "fa fa-file-pdf-o";
        break;
      case 'png':
        class_name = "fa fa-file-image-o";
        break;
      case 'jpg':
        class_name = "fa fa-file-image-o";
        break;
      case 'jpeg':
        class_name = "fa fa-file-image-o";
        break;
      case 'gif':
        class_name = "fa fa-file-image-o";
        break;
      case 'bmp':
        class_name = "fa fa-file-image-o";
        break;
      case 'txt':
        class_name = "fa fa-file-text-o";
        break;
      case 'tif':
        class_name = "fa fa-file-text-o";
        break;
      case 'tiff':
        class_name = "fa fa-file-text-o";
        break;

      case 'doc':
        class_name = "fa fa-file-word-o";
        break;
      case 'docx':
        class_name = "fa fa-file-word-o";
        break;
      case 'rtf':
        class_name = "fa fa-file-word-o";
        break;
      case 'wks':
        class_name = "fa fa-file-word-o";
        break;
      case 'wps':
        class_name = "fa fa-file-word-o";
        break;
      case 'wpd':
        class_name = "fa fa-file-word-o";
        break;

      case 'xlr':
        class_name = "fa fa-file-excel-o";
        break;
      case 'xls':
        class_name = "fa fa-file-excel-o";
        break;
      case 'xlsx':
        class_name = "fa fa-file-excel-o";
        break;
      case 'csv':
        class_name = "fa fa-file-excel-o";
        break;

      case 'ppt':
        class_name = "fa fa-file-powerpoint-o";
        break;

      case 'pps':
        class_name = "fa fa-file-powerpoint-o";
        break;
      case 'pptx':
        class_name = "fa fa-file-powerpoint-o";
        break;

      default:
        class_name = "file-text-o";

    }

    return class_name;


  }

}



// WEBPACK FOOTER //
// /codebuild/output/src2008182461/src/src/app/generic-ui-components/additional-attachment/additional-attachment.component.ts